import * as React from 'react'
import styles from "./ActivitySelection.module.scss";
import SelectBox from "../../../../../Componnets/SelectBox/SelectBox";

const ActivityItem = (props) => {
  const operands = ["starts_with", "ends_with", "not_starts_with", "not_ends_with", "include", "not_include"]

  const handleChangeActivityProperties = (type, value) => {
    props.onChangeProperties(props.index, {
      ...props.data,
      [type]: value
    })
  }

  return (
    <div key={props.key} className={styles.mainContent}>
      {
        props.data.logic &&
          <div className={styles.logicTag} onClick={() => handleChangeActivityProperties("logic", props.data.logic === "AND" ? "OR" : "AND")}>
            {props.data.logic}
          </div>
      }
      <div className={styles.selectBoxes}>
        <div className={styles.selectRule}>
          <SelectBox style={{backgroundColor: props.data.operand?.[0] ? "transparent" : "#F0F2FF", border: props.data.operand?.[0] ? "1px solid #C2C7ED" : "none"}} block label={"Rule"} dropDownValue={props.data.operand?.[0]} emptyTitle={"Select the rule..."}>
            {
              operands.map((operand, index) => <div key={`${operand}_${index}`} onClick={() => handleChangeActivityProperties("operand", [operand])}>{operand}</div>)
            }
          </SelectBox>
        </div>
        <div className={styles.selectActivities}>
          <SelectBox multiSelect style={{backgroundColor: props.data.value?.length ? "transparent" : "#F0F2FF", border: props.data.value?.length ? "1px solid #C2C7ED" : "none"}} block label={"Activities (Multiple)"} options={props?.variantsList?.map(variant => ({title: variant, value: variant}))} dropDownValue={props.data.value || []} onSelectOption={(options) => handleChangeActivityProperties("value", options)} emptyTitle={"Select activities name..."} />
        </div>
      </div>
    </div>
  )
}

export default ActivityItem